"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$Error = void 0;
class $Error extends Error {
    code;
    constructor(code, message) {
        super(message ? `${code}: ${message}` : code);
        this.code = code;
    }
}
exports.$Error = $Error;
